import React from 'react';

import { Block } from './Block.jsx';
import { EmptyPlaceholder } from '../layout/Builder.jsx';
import Utilities from './Utilities.jsx';

function EmbedComponent(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => { setId(`${props.embedType || 'embed-content'}-${new Date().getTime()}`) }, []);

    const style = { position: 'relative' };
    if (props.inLayout) {
        style.width = '100%';
    }
    Utilities.copyObject(props.style, style);
    if (props.builder) {
        style.pointerEvents = 'none';
    }
    const flexStyle = { display: 'flex', flexDirection: 'column', position: 'relative' };
    let url;
    if (id != undefined && Utilities.isValidURL(document, props.url)) {
        url = props.url;
    }
    let verticalAlignment;
    const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit(style, props, undefined, (propName, propValue, propUnit) => {
        switch (propName) {
            case 'alignItems':
                if (!props.inLayout) {
                    flexStyle.margin = Block.marginForAlignment(propValue);
                }
                return true;
            case 'height':
            case 'width':
                if (propValue && propUnit) {
                    flexStyle[propName] = `${propValue}${propUnit}`;
                }
                return true;
            case 'isCropped':
                return true;
            case 'verticalAlignment':
                verticalAlignment = propValue;
                return true;
        }
    });
    const frameStyle = { height: '100%', width: '100%' };
    if (!flexStyle.height && !flexStyle.width) {
        // No height or width set => Keep a 16:9 aspect ratio
        flexStyle.paddingBottom = '56.25%';
        frameStyle.position = 'absolute';
    } else if (props.inLayout) {
        frameStyle.position = 'absolute';

        const height = parseFloat(flexStyle.height);
        const width = parseFloat(flexStyle.width);
        if (!isNaN(height) && !isNaN(width) && width > 0) {
            // Custom height and width set => Maintain aspect ratio inside of layout container
            flexStyle.height = undefined;
            flexStyle.width = undefined;
            flexStyle.paddingBottom = `${100.0 * (height / width)}%`;
        }
    }
    if (layoutStyles.style.maxHeight) {
        // Vertical alignment is available when max height is set
        layoutStyles.style.alignItems = verticalAlignment;
        layoutStyles.style.display = 'flex';
        if (!flexStyle.width) {
            // Container display flex requires child to have extent
            flexStyle.width = '100%';
        }
    }
    let className = 'embed__cont';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (!props.inLayout) {
        className += ' cont--kit__content';
    }
    let content = (
        <div className={className} style={layoutStyles.style}>
            <div style={flexStyle}>
                {
                    url != undefined &&
                    //https://github.com/facebook/react/issues/7848
                    <iframe
                        allowFullScreen={true} //emits warning if "true"
                        webkitallowfullscreen="true"
                        mozallowfullscreen="true"
                        frameBorder="0"
                        src={url}
                        style={frameStyle} />
                }
                {
                    props.builder &&
                    url == undefined &&
                    <EmptyPlaceholder />
                }
            </div>
        </div>
    );
    if (layoutStyles.containerStyle) {
        content = <div className="cont--kit__wrapper" style={layoutStyles.containerStyle}>{content}</div>
    }
    return content;
}

export default { Component: EmbedComponent };